import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import {connect} from "react-redux";
import { guestPersonalDetails } from '../../../services/adapters/guest';

const AdminViewUserAccount = ({guest, event, code, onChange, dispatch, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const currentFormData = guestPersonalDetails(guest);

    const [form, setForm] = useState({
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        company: '',
        job_title: '',
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {

        adminHttp
            .put(`/events/${event.id}/guests/${guest.id}/update`, form)
            .then(res => {
                setError(null);
                setShow(false);
                onChange();
            }).catch((error) => {
                setError(error.response?.data);
            });
    };

    useEffect(() => {
        setForm({...form, ...currentFormData});
    }, []);

    return (
        <>
            <button {...rest} onClick={handleShow}>View User Account</button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>User Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mt-2">
                        <p className="mb-1">Code:</p>
					    <div className="bordered-gray text-center">{code}</div>
                    </div>
                    <div className="mt-3">
                        <p className="mb-0">Host link:</p>
                        <a href={window.location.origin} target="_blank" className="link text-primary">{window.location.origin}</a>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="w-100 text-center">
                        <div className="btn btn-sm btn-secondary" onClick={handleClose}>OK</div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminViewUserAccount);
